import { toast, ToastOptions } from "react-toastify";
import { AddMessageProps } from "../types/types";

export const addMessage = (props: AddMessageProps) => {
  const {
    message,
    messageId,
    autoClose,
    type,
    hideProgressBar,
    keepOpen,
    closeOnClick,
    closeButton,
    position,
    onClose,
    onOpen,
    clearWaitingQueue,
  } = props;

  const options: ToastOptions = {
    containerId: messageId,
    autoClose: keepOpen ? false : autoClose,
    type: type || "success",
    hideProgressBar: keepOpen ? true : hideProgressBar,
    closeOnClick: keepOpen ? false : closeOnClick,
    closeButton: closeButton,
    position: position || "top-center",
    onClose,
    onOpen,
  };
  clearWaitingQueue ??
    toast.clearWaitingQueue({
      containerId: messageId,
    });
  return toast(message, options);
};
